import { InputAdornment, TextField, IconButton, Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';
import { ComponentProps, MouseEvent } from 'react';
import { useTenants } from 'TenantModule/hooks/useTenants';
import { Tenant } from 'TenantModule/types';

export const TenantSelector = ({
  onClick,
  tenantId,
  onClear,
  helperText,
}: {
  onClick: ComponentProps<'div'>['onClick'];
  tenantId: Tenant['id'] | null;
  onClear?: () => void;
  helperText?: string;
}) => {
  const { getTenant } = useTenants();
  const tenant = tenantId ? getTenant({ tenantId }) : null;

  const tenantLabel = tenant ? tenant.tenantName : '';

  const handleClear = (e: MouseEvent) => {
    e.stopPropagation();
    onClear?.();
  };

  return (
    <TextField
      variant="outlined"
      label="Tenant"
      value={tenantLabel}
      placeholder="Select a tenant"
      onClick={onClick}
      helperText={helperText}
      slotProps={{
        input: {
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {tenantLabel && onClear && (
                  <IconButton size="small" onClick={handleClear} sx={{ mr: -0.5 }}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
                <ArrowDropDownIcon />
              </Box>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
